import { UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './RosreestrSubtitle.css';

interface IRosreestrSubtitleProps {
  deck: string;
  bottom?: string;
}

export const RosreestrSubtitle: React.FC<IRosreestrSubtitleProps> = ({ deck, bottom }) => {
  return (
    <div className={styles['subtitle']}>
      <UIText1 color="text-primary-default" as="p">
        {deck}
      </UIText1>

      {bottom && (
        <UIText1 color="text-primary-default" as="p">
          {bottom}
        </UIText1>
      )}
    </div>
  );
};
